import { render, staticRenderFns } from "./PreliminaryReportRND.vue?vue&type=template&id=73abd6b0&"
import script from "./PreliminaryReportRND.vue?vue&type=script&lang=ts&"
export * from "./PreliminaryReportRND.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports